import { render } from "./EdicionMarcaDhs.vue?vue&type=template&id=8725b5e0&scoped=true"
import script from "./EdicionMarcaDhs.vue?vue&type=script&lang=js"
export * from "./EdicionMarcaDhs.vue?vue&type=script&lang=js"

import "./EdicionMarcaDhs.vue?vue&type=style&index=0&id=8725b5e0&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8725b5e0"]])

export default __exports__